import { creditInstallmentOptions } from '@valiosascrm/shared';
import type { PaymentMethod } from '@/services/cash-flow';
import { FormField, NativeSelect } from '@/v2/design-system/primitives';

/** 65.57: a única forma que parcela. */
export const CREDIT_CARD_METHOD: PaymentMethod = 'credit_card';

/** 65.57: parcelas do crédito que têm regra de taxa ativa; sem as regras lidas ainda, nada. */
export function creditRuleInstallmentsOf(
  rules: ReadonlyArray<{ isActive: boolean; paymentMethod: string; installments: number | null }> | undefined,
): number[] | undefined {
  if (!rules) return undefined;
  return rules
    .filter((rule) => rule.isActive && rule.paymentMethod === CREDIT_CARD_METHOD)
    .map((rule) => rule.installments ?? 1);
}

export const missingFeeRuleHelp = (installments: number) =>
  `Sem taxa cadastrada para ${installments}x: entra sem taxa. Cadastre em Configurações → Taxas.`;

/**
 * 65.57 (decisão 1A): no crédito, o campo de parcelas aparece sempre — de 1x a 12x, ou até a
 * maior parcela com regra de taxa ativa. A regra cadastrada decide só a taxa; sem ela, o campo
 * diz o que acontece com a escolhida.
 */
export function CreditInstallmentsField({
  id,
  value,
  onChange,
  ruleInstallments,
  missingRuleText = missingFeeRuleHelp,
  disabled,
  className,
}: {
  id: string;
  value: number;
  onChange: (installments: number) => void;
  /** Parcelas do crédito que têm regra de taxa ativa (1 = à vista); `undefined` enquanto as regras carregam. */
  ruleInstallments: readonly number[] | undefined;
  missingRuleText?: (installments: number) => string;
  disabled?: boolean;
  className?: string;
}) {
  const options = creditInstallmentOptions(ruleInstallments ?? []);
  // Antes de as regras chegarem, o campo não afirma que falta regra.
  const helper = !ruleInstallments || ruleInstallments.includes(value) ? undefined : missingRuleText(value);
  return (
    <FormField label="Parcelas" htmlFor={id} helper={helper} className={className}>
      <NativeSelect id={id} value={String(value)} disabled={disabled} onChange={(event) => onChange(Number(event.target.value))}>
        {options.map((count) => (
          <option key={count} value={String(count)}>
            {count === 1 ? 'À vista (1x)' : `${count}x`}
          </option>
        ))}
      </NativeSelect>
    </FormField>
  );
}
